// Libs
import React from 'react';
import AsyncSelect from 'react-select/async';

// Services & Helpers
import SearchService from 'services/SearchService';

//-------------------------------------------------------------------------------------------------------------------

export default class SearchBox extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            inputValue: '',
            key: 0
        };
    }
    
    render() {
        const { inputValue, key } = this.state;
        const { types, ignoreIDs } = this.props;
        
        return (
            <AsyncSelect
                key={`${key}`}
                className="search-box"
                classNamePrefix="search-box"
                inputValue={inputValue}
                cacheoptions
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                }}
                noOptionsMessage={() => inputValue ? 'Sorry, no results' : 'Start typing...'}
                getOptionValue={u => u.id}
                getOptionLabel={u => <>
                    {u.name}
                    {u.type == 'booking' && <> ({u.status})</>}
                    {u.type == 'instructor' && u.activeStatus && <> ({u.activeStatus})</>}
                </>}
                placeholder="Search..."
                loadOptions={async (query) => {
                    const searchResults = await SearchService.search({ query, types, ignoreIDs });
                    return searchResults;
                }}
                onInputChange={(inputValue, e) => this.setState({ inputValue })}
                onChange={item => {
                    this.props.onSelect(item);
                    this.setState({ key: key + 1 });
                }}
            />
        );
    }
}
